export enum ENoteTypeFile {
  Annotation = 'ANOTACAO',
  ConditionOrDisease = 'CONDICAO_DOENCA',
  Drug = 'MEDICAMENTO',
  Folder = 'PASTA',
}
